import React, { FC } from "react"
import clsx from "clsx"

interface IProps {
  text: string
  handler?: any
  className?: string
  disabled?: boolean
}

export const NavButton: FC<IProps> = (props) => {
  const { text, handler, className, disabled = false } = props
  return (
    <button
      className={clsx(
        "btn btn-md text-md font-bold px-4 py-2 border bg-transparent border-purple rounded-md flex items-center justify-center hover:bg-purple text-[rgba(139,92,246,1)] dark:text-white hover:text-white disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-[rgba(139,92,246,1)] dark:disabled:hover:text-white",
        className
      )}
      onClick={() => handler?.()}
      disabled={disabled}
    >
      {text}
    </button>
  )
}
